import React from 'react'
import HelpIcon from '@material-ui/icons/Help'
import { Typography, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: 'text-top',
    marginRight: theme.spacing(1),
    fontSize: '1.2rem',
    color: theme.palette.primary.main,
  },

  title: {
    fontWeight: '600',
  },
}))

const SidebarSection = ({ title, children, ...props }) => {
  const classes = useStyles()
  return (
    <Box mb={2} {...props}>
      {title && (
        <Typography variant="body1" className={classes.title} gutterBottom>
          <HelpIcon className={classes.icon} />
          <span>{title}</span>
        </Typography>
      )}
      {children}
    </Box>
  )
}

export default SidebarSection
